import styled from 'styled-components';

import { SCREEN } from '../../../../../assets/styles/constants';
import { grid, flex } from '../../../../../assets/styles/flex-grid';

export const TableListingWrapper = styled.div`
	transform: scale(0.85);
	margin: auto;
	width: fit-content;

	${SCREEN.SMALL} {
		transform: scale(0.65);
	}
`;

export const Wrapper = styled.div`
	${grid}

	${SCREEN.SMALL} {
		overflow: hidden;
		${flex};
	}
`;
